import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { FeedbackProvider } from "./context/cmscontext";
import 'bootstrap/dist/css/bootstrap.min.css';
// import 'semantic-ui-css/semantic.min.css'
import "animate.css";
import {
  // BrowserRouter as Router,
  Switch,
  Redirect,
  Route,
} from "react-router-dom";
import "./App.css";
import { useLocation } from 'react-router-dom'
import { AuthRoute, PrivateRoute, PublicRoute, useAuth } from "./router/index";
import CurveNavbar from "./components/Navbar/CurveNavbar";
import Navbar from "./components/Navbar/Navbar";


import * as Pages from "./pages/index";
import Toaster from "./components/Toaster";
import OverLayLoader from "./components/OverLayLoader";
import Magnifier from "./components/Magnifer";
import Footer from "./components/Footer";
import FooterMini from "./components/Footer Social";
import { get } from "./services/localStorage";
import { LOGIN, LOG_OUT, UPDATE_AUTH } from "./constant";
import InspectionApp from "./inspection/InspectionApp";
import DealersApp from "./dealers/DealersApp";
import DealersPortalGate from "./components/DealersPortalGate";
import { captureReferralCodeFromSearch } from "./utils/userIdentity";
import Labels from "./services/apiLabels";
import config from "./config";
import { pickUserType, USER_TYPE_DEALER, isClientUser } from "./utils/userTypes";
import { syncDealersSessionFromHomeLogin } from "./utils/dealerSessionSync";
import { syncAuthCredits } from "./utils/accountActivity";
import { getAuthToken, getAuthUserId } from "./utils/userIdentity";

const OnboardingTour = React.lazy(() => import("./components/OnboardingTour"));

// import 'semantic-ui-css/semantic.min.css'
//
function App(props) {


// =======================================This is Client Side Project==================


  const { auth, login, logOut,data } = props;
  const localStorage_auth = () => {
    const localStorage_auth_data = get({ key: "auth" });
    return localStorage_auth_data
      ? localStorage_auth_data.token
        ? localStorage_auth_data
        : {}
      : {};
  };
  //
  useEffect(() => {
    const auth_data = localStorage_auth();
    if (!auth.token && auth_data.token) {
      login(auth_data);
    } else if (auth.token && !auth_data.token) {
      logOut();
    }
  }, [auth]);

  // Login often omits profile fields — hydrate name/email/contact from API.
  useEffect(() => {
    const userId = auth?.id || auth?.user?.id || auth?.user_id;
    const token = auth?.token;
    if (!token || !userId) return undefined;

    const needsProfile =
      !auth.firstname ||
      !auth.email ||
      !auth.username ||
      auth.type == null ||
      auth.type === "" ||
      !auth.mobile_number ||
      !auth.postcode;

    if (!needsProfile) return undefined;

    let cancelled = false;
    fetch(`${config.baseUrl}${Labels.getupdateprofile}${userId}/`, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((response) => {
        if (cancelled) return;
        if (response?.message?.type === "error") return;
        const payload = response?.data || response || {};
        const user =
          payload?.user ||
          payload?.data?.user ||
          (payload?.data && typeof payload.data === "object"
            ? payload.data
            : null) ||
          payload;
        if (!user || typeof user !== "object") return;

        const userType = pickUserType(user, payload, auth);
        const first =
          user.firstname || user.first_name || auth.firstname || "";
        const last = user.lastname || user.last_name || auth.lastname || "";
        const patch = {};
        if (first && !auth.firstname) {
          patch.firstname = first;
          patch.first_name = first;
        }
        if (last && !auth.lastname) {
          patch.lastname = last;
          patch.last_name = last;
        }
        const email = user.email || payload?.email || "";
        const username = user.username || "";
        const mobile =
          user?.mobile_number || user?.phone || payload?.mobile_number || "";
        const postcode =
          user?.postcode || user?.postal_code || payload?.postcode || "";
        const image =
          user.image ||
          user.image_url ||
          user.profile_image ||
          user.profile_image_url ||
          "";

        if (email && !auth.email) patch.email = email;
        if (username && !auth.username) patch.username = username;
        if (mobile && !auth.mobile_number) patch.mobile_number = mobile;
        if (postcode && !auth.postcode) patch.postcode = postcode;
        if (image && !auth.image) patch.image = image;
        if (userType != null && (auth.type == null || auth.type === "")) {
          patch.type = userType;
        }

        if (!Object.keys(patch).length) return;
        props.updateAuth(patch);
        if ((userType ?? auth.type) === USER_TYPE_DEALER) {
          syncDealersSessionFromHomeLogin({
            ...auth,
            ...user,
            ...patch,
            type: userType ?? auth.type,
          });
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [auth?.token, auth?.id, auth?.firstname, auth?.email, auth?.username, auth?.type]);

  // Keep Available credits fresh for already-logged-in sessions (login payload goes stale).
  useEffect(() => {
    const userId = getAuthUserId(auth);
    const token = getAuthToken(auth);
    if (!token || !userId) return undefined;

    let cancelled = false;
    syncAuthCredits({
      userId,
      token,
      dispatch: (action) => {
        if (!cancelled && action?.type === UPDATE_AUTH) {
          props.updateAuth(action.payload || {});
        }
      },
    });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refresh when identity changes
  }, [auth?.token, auth?.id]);
  //
  const [navbarDimensions, setnavbarDimensions] = useState({
    width: 0,
    height: 88,
  });

  const location = useLocation();
  const isHome = location.pathname === "/";
  const isInspectionApp =
    location.pathname === "/inspection" ||
    location.pathname.startsWith("/inspection/");
  const isDealersApp = location.pathname.startsWith("/dealers");
  const isPdfReport = location.pathname.startsWith("/pdf/");
  const isEmbeddedApp = isInspectionApp || isDealersApp;
  const hidePublicChrome =
    isEmbeddedApp ||
    isPdfReport ||
    location.pathname === "/carreport" ||
    location.pathname === "/contactusmobile";

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, [location]);

  useEffect(() => {
    captureReferralCodeFromSearch(location.search);
  }, [location.search]);

  useEffect(() => {
    if (!isPdfReport) return undefined;
    const root = document.documentElement;
    const body = document.body;
    const prevHtmlOverflow = root.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    root.style.overflow = "hidden";
    body.style.overflow = "hidden";
    return () => {
      root.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
    };
  }, [isPdfReport]);
  // // console.log("Location ",location)
//  console.warn = () => {};
  // console.log = console.warn = console.error = () => {};

  return (
    <>
      <FeedbackProvider data={data}>
        {!hidePublicChrome ? (
          <div className={`fixed-top pi-header-fixed${isHome ? " pi-header-fixed--overlay" : ""}`}>
            <CurveNavbar
              setnavbarDimensions={setnavbarDimensions}
              auth={auth}
            />
          </div>
        ) : null}

        <div className={isHome ? "pi-home-shell" : undefined}>
          {!hidePublicChrome ? (
          <div
            style={{
              maxWidth: navbarDimensions.width,
              height: isHome ? 0 : navbarDimensions.height,
            }}
          />
          ) : null}
          <Switch>
          <Redirect from="/inspections" to="/inspection" />
          <Route path="/inspection">
            <InspectionApp />
          </Route>
          <Route path="/dealers">
            <DealersPortalGate auth={auth}>
              <DealersApp />
            </DealersPortalGate>
          </Route>
          <PrivateRoute exact path="/evaluation" auth={auth}>
            <Pages.Evaluation navbarDimensions={navbarDimensions} />
          </PrivateRoute>
          <AuthRoute exact path="/login" auth={auth}>
            <Pages.Login navbarDimensions={navbarDimensions} />
          </AuthRoute>
          <AuthRoute exact path="/signup" auth={auth}>
            <Pages.Signup navbarDimensions={navbarDimensions} />
          </AuthRoute>
          <PrivateRoute exact path="/profile" auth={auth}>
            <Pages.AccountProfile navbarDimensions={navbarDimensions} />
          </PrivateRoute>
          <PrivateRoute exact path="/credits" auth={auth}>
            <Pages.AccountCredits navbarDimensions={navbarDimensions} />
          </PrivateRoute>
          <PrivateRoute exact path="/change-password" auth={auth}>
            <Pages.AccountChangePassword navbarDimensions={navbarDimensions} />
          </PrivateRoute>
          <PrivateRoute exact path="/referral" auth={auth}>
            <Pages.AccountReferral navbarDimensions={navbarDimensions} />
          </PrivateRoute>
          <Route exact path="/contactus">
            <Pages.ContactUs navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/contactusmobile">
            <Pages.ContactUs navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/dostprogram">
            <Pages.DostProgram navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/privacypolicy">
            <Pages.PrivacyPolicy navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/faqs">
            <Pages.FAQs navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/requridocuments">
            <Pages.Documents navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/terms">
            <Pages.Terms navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/cars">
            <Pages.Cars navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/aboutus">
            <Pages.AboutUs navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/forgetpassword">
            <Pages.Forget navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/shiping">
            <Pages.Shiping navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/carupdate">
            <Pages.CarUpdate navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/carsteps">
            <Pages.Car_Steps navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/carsteps/:id">
            <Pages.Car_Steps navbarDimensions={navbarDimensions} />
          </Route>

          <Route exact path="/bookappointment">
            <Pages.EvaluationAppoitmnt navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/bookappointmentnew">
            <Pages.EvaluationAppoitmnt navbarDimensions={navbarDimensions} />
          </Route>

          <Route exact path="/carreport">
            <Pages.CarReport navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/pdf/:id/report">
            <Pages.ConditionReportPdf />
          </Route>

          <Route exact path={`/resetpassword/:id/:token`}>
            <Pages.ChagePassword navbarDimensions={navbarDimensions} />
          </Route>

          <Route exact path="/cardamage">
            <Pages.CarDamage navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/myappointment">
            <Pages.MyAppointment navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/myappointmentupdate">
            <Pages.Appoinmentupdate navbarDimensions={navbarDimensions} />
          </Route>

          <Route exact path="/myappointmentdetail">
            <Pages.MyAppointmentDetail navbarDimensions={navbarDimensions} />
          </Route>
          <Route exact path="/cardetail">
            <Pages.CarDetail navbarDimensions={navbarDimensions} />
          </Route>

          <Route exact path="/">
            <Pages.Landingmain navbarDimensions={navbarDimensions} />
          </Route>
          {/* <Redirect from="/" to="/" /> */}
        </Switch>
        </div>
        <Toaster />
        <OverLayLoader />
        {auth?.token && isClientUser(auth) ? (
          <React.Suspense fallback={null}>
            <OnboardingTour auth={auth} audience="client" />
          </React.Suspense>
        ) : null}
        {/* || location.pathname=="/carupdate" */}
        {isEmbeddedApp ||
        isPdfReport ||
        location.pathname == "/bookappointment" ||
        location.pathname == "/bookappointmentnew" ||
        location.pathname === "/contactusmobile" ? null : (
          <>
            <footer className="app-footer-shell footer-v2-shell pi-footer pi-footer--gradient">
              <div className="footer-v2__atmosphere pi-footer__fx" aria-hidden="true">
                <span
                  className="pi-footer__photo"
                  style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/images/hero-rebrand-luxury-road.jpg)`,
                  }}
                />
                <span className="footer-v2__orb footer-v2__orb--teal" />
                <span className="footer-v2__orb footer-v2__orb--gold" />
                <span className="footer-v2__orb footer-v2__orb--violet" />
                <span className="pi-footer__grid" />
                <span className="pi-footer__aurora pi-footer__aurora--a" />
                <span className="pi-footer__aurora pi-footer__aurora--b" />
                <span className="pi-footer__beam" />
                <span className="footer-v2__mesh" />
                <span className="footer-v2__grain" />
                <span className="footer-v2__scrim" />
              </div>
              <Footer />
              <FooterMini></FooterMini>
            </footer>
          </>
        )}
      </FeedbackProvider>
    </>
  );
}
const mapStateToProps = (state) => ({
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
  login: (data) =>
    dispatch({
      type: `${LOGIN}_SUCCESS`,
      payload: { ...data },
    }),
  logOut: () =>
    dispatch({
      type: LOG_OUT,
    }),
  updateAuth: (payload) =>
    dispatch({
      type: UPDATE_AUTH,
      payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
